import React from 'react';
import { DateTime } from 'luxon';


type DateProps = {
    date?: string | DateTime,
    short?: boolean,
}

const Date = ({date, short = false}: DateProps) => {
    if (!date) return null;

    const opts: Intl.DateTimeFormatOptions = {
        month: short ? 'short' : 'long',
        day: 'numeric',
    };

    if (typeof date === 'string') {
        date = DateTime.fromISO(date);
    }

    if (DateTime.now().year !== date.year) {
        opts.year = 'numeric';
    }

    return <>{date.toLocaleString(opts)}</>;
};

export default Date;
